"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const TaskPage_1 = require("../../base/TaskPage");
const autosave_1 = require("../../../../hooks/autosave");
const Bathroom_1 = require("./Bathroom");
const helper_1 = require("./helper");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const validation_1 = require("../../../../hooks/validation");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Label_1 = require("../../../components/input/label/Label");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const bathroomCount = (bathrooms) => {
    if (!bathrooms || !bathrooms.length)
        return 1;
    return Math.max(...bathrooms.map((b) => b.bathroom_number));
};
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError, } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [, errMsg] = (0, validation_1.useBathroomValidation)('bathrooms', property === null || property === void 0 ? void 0 : property.bathrooms);
    const bathrooms = property === null || property === void 0 ? void 0 : property.bathrooms.sort((a, b) => a.bathroom_number - b.bathroom_number);
    const maxBathroomNumber = bathroomCount(bathrooms);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.BATHROOMS, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError, contextualMessage: errMsg }, bathrooms && (React.createElement(TaskPage_1.TaskLayout, { width: 50 },
        React.createElement(HorizontalRule_1.HorizontalRule, null),
        React.createElement(Spacer_1.Spacer, { spacing: "large" }),
        React.createElement(TaskPage_1.TaskColumn, null,
            React.createElement(MarginWrapper_1.MarginWrapper, null,
                React.createElement(Heading_1.HeadingSmall, null, "Number of bathrooms"),
                React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                React.createElement(Label_1.ParagraphLabel, { htmlFor: "arrival-time-clicker" }, "How many bathrooms does this property have?"),
                React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                React.createElement(merlin_input_stepper_1.InputStepper, { id: "arrival-time-clicker", onClick: (newValue) => {
                        if (newValue > bathrooms.length) {
                            bathrooms.push((0, helper_1.newBathroom)(maxBathroomNumber, property.id));
                        }
                        else {
                            bathrooms.pop();
                        }
                        update({ bathrooms });
                    }, value: (bathrooms && bathrooms.length) || 0, valueFormatter: (value) => `${value} ${value > 1 ? 'bathrooms' : 'bathroom'}` }),
                React.createElement(Spacer_1.Spacer, null),
                bathrooms.some((b) => b.toilet_type === 'standard' &&
                    b.bath_type === 'none' &&
                    b.shower_type === 'none') && (React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'half-bathrooms', text: "Any bathrooms that only have a toilet and sink are considered a half bath." })),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                bathrooms.map((b, index) => {
                    return (React.createElement(Bathroom_1.Bathroom, { bathroom: b, bathroomNumber: index + 1, key: `bathroom-${index}`, update: (next) => {
                            bathrooms[index] = next;
                            update({ bathrooms });
                        } }));
                })))))));
};
//# sourceMappingURL=BathroomsPage.js.map